import {
  Button,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
} from '@mui/material'
import { IQuestionV2 } from '../../store/reports/types'
import DividerTAG from '../DividerTAG'
import FormLayout from '../forms/FormLayout'

import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import AddIcon from '@mui/icons-material/Add'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import {
  addCustomSubjectFields,
  addNewSubjectForm,
  removeSubjectForm,
  resetSubjectValues,
  setSubjectValues,
  updateSubjectsCustomField,
} from '../../store/questions/questionsSlice'
import metricUtils from '../../pages/MetricsPage/utils'
import questionsSelector from '../../store/questions/questionsSelector'
import { Box } from '@mui/system'
import LabelErrorTAG from '../LabelErrorTAG'
import { PhotoCamera } from '@mui/icons-material'
import { ChangeEvent, useCallback, useState } from 'react'
import selectOptions from '../../constants/selectOptions'
import { selectStyle, textAreaStyle } from '../../constants/styleConstants'
import colors from '../../constants/colors'
import ModalTAG from '../ModalTAG'
import CardTAG from '../CardTAG'
import TextInput from '../TextInput'
import { useForm } from 'react-hook-form'
import utils from '../forms/ReportingPartyForm/utils'
import { vestResolver } from '@hookform/resolvers/vest'
import RemoveButton from '../RemoveButton'
import { IOptionItem } from '../Dropdown/types'
import reporterConstants from '../../components/forms/ReportingPartyForm/constants'

const imageUploadRowStyle = {
  height: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '30vh',
  maxHeight: '30vh',
  width: '30vh',
}

const imageMessageStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  border: '1px solid #ccc',
  borderRadius: '10px',
}

interface ISubjectFormQuestion {
  question: IQuestionV2
}
const SubjectFormQuestion: React.FC<ISubjectFormQuestion> = ({ question }) => {
  const [imagePreview, setImagePreview] = useState<string | null>(null)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const subjectsData = useSelector(questionsSelector.newCaseSubjects)
  const custom_fields = useSelector(questionsSelector.subjectCustomFieldsSelector)
  const dispatch = useDispatch<AppDispatch>()

  const addNewTagFormMethods = useForm<any>({
    defaultValues: { newTag: '' },
    mode: 'onChange',
    shouldFocusError: false,
    resolver: vestResolver(utils.newTagFormValidation),
  })
  const {
    register: newTagRegister,
    handleSubmit: newTagHandleSubmit,
    formState: formStateNewTag,
    reset: resetNewTag,
  } = addNewTagFormMethods

  const addSubjectHandler = () => {
    const subjectId = metricUtils.getRandomInt()
    dispatch(
      addNewSubjectForm({
        subjectId,
      }),
    )
  }

  const removeHandler = (subjectId: number) => {
    dispatch(removeSubjectForm({ subjectId }))
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, subjectId: number) => {
    dispatch(setSubjectValues({ field: e.target.name, value: e.target.value, subjectId }))
  }

  const onChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>, subjectId: number) => {
    dispatch(setSubjectValues({ field: e.target.name, value: e.target.value, subjectId }))
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>, subjectId: number) => {
    if (e?.target?.files) {
      const file = e?.target?.files[0]
      file.arrayBuffer().then(arrayBuffer => {
        const blob = new Blob([new Uint8Array(arrayBuffer)], { type: file.type })
        dispatch(setSubjectValues({ field: e.target.name, value: blob, subjectId }))
      })
      setImagePreview(URL.createObjectURL(file))
    }
  }

  const onChangeHandler = (e: SelectChangeEvent, subjectId: number) => {
    dispatch(setSubjectValues({ field: e.target.name, value: e.target.value, subjectId }))
  }

  const customFieldOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>, subjectId: number) => {
    dispatch(
      updateSubjectsCustomField({
        subjectId: subjectId,
        title: e.target.name,
        value: e.target?.value,
      }),
    )
  }
  const renderCustomFields = (subjectId: number) => {
    const userFields = custom_fields?.find(fields => fields?.subjectId === subjectId)
    return (
      userFields?.custom_fields &&
      userFields?.custom_fields.map((field, index) => {
        return (
          <Box sx={{ width: '100%' }} key={`${field?.title}-${index}`}>
            <LabelErrorTAG label={field.title} />
            <TextareaAutosize
              name={field.title}
              key={field.title}
              value={field?.description}
              style={textAreaStyle}
              minRows={5}
              placeholder={''}
              onChange={e => {
                customFieldOnChange(e, subjectId)
              }}
            />
          </Box>
        )
      })
    )
  }

  const openModalHandler = () => {
    setOpenModal(true)
  }
  const addNewTagSubmitHandler = (values: { newTag: string }, subjectId: number) => {
    const { newTag } = values

    const userFields = custom_fields?.find(fields => fields?.subjectId === subjectId)

    const tagExists = userFields?.custom_fields?.find(field => field?.title === newTag)
    if (!tagExists) {
      dispatch(
        addCustomSubjectFields({
          subjectId,
          fields: [
            ...(userFields?.custom_fields ?? []),
            {
              title: newTag,
              description: '',
            },
          ],
        }),
      )
      resetNewTag({ newTag: '' })
      setOpenModal(false)
    }
  }
  const getMessageNewTag = useCallback(
    (field: 'newTag') => {
      if (!formStateNewTag.errors[field]) return ''

      return formStateNewTag.errors[field]!.message
    },
    [formStateNewTag],
  )

  const renderSelectOptions = (options: IOptionItem[]) => {
    return options.map((selectOption, index) => {
      return (
        <MenuItem value={selectOption.value} key={`${selectOption.label}-${index}`}>
          <Typography variant='h4'>{selectOption.label}</Typography>
        </MenuItem>
      )
    })
  }

  const handleUserTypeChange = (e: SelectChangeEvent, subjectId: number, currentType: string) => {
    if (currentType !== '') {
      dispatch(resetSubjectValues({ subjectId, subjectRenderType: e.target.value }))
      return
    }
    dispatch(setSubjectValues({ field: 'subjectRenderType', value: e.target.value, subjectId }))
  }

  const renderTextFields = (subject: any) => {
    return reporterConstants.textFieldBasedOnSubjectType[subject?.subjectRenderType].map(field => (
      <Stack key={`${subject?.subjectId}-${field?.fieldName}`}>
        <LabelErrorTAG label={field?.label} />
        <TextField
          value={subject?.[field?.fieldName]}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e, subject?.subjectId)
          }}
          variant='standard'
          type={'text'}
          fullWidth
          id={field.fieldName}
          name={field.fieldName}
        />
      </Stack>
    ))
  }

  const renderSelect = renderSelectOptions(
    selectOptions.subjectTypes.filter(
      subjectType => !['LAW_ENFORCEMENT', 'REGULATORY_AGENT'].includes(subjectType.value),
    ),
  )

  const resolveForm = (subject: any) => {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.8rem',
          mt: '1.8rem',
        }}
      >
        <Grid container xs={12} spacing={2}>
          {/* <Grid item xs={12} sm={4}>
            <Stack sx={imageUploadRowStyle}>
              {!subject?.image && (
                <Box sx={imageMessageStyle}>
                  <Typography sx={{ textAlign: 'center' }}>Upload Profile Image</Typography>
                </Box>
              )}
              {subject?.image && (
                <Box sx={{ width: { xs: '100%' }, height: { xs: '100%' } }}>
                  <img
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    src={URL.createObjectURL(subject?.image as unknown as Blob)}
                  />
                </Box>
              )}
              <Button
                variant='submitFormButton'
                component='label'
                sx={{ mt: '18px' }}
                endIcon={<PhotoCamera />}
              >
                <Typography variant='bodyBold'>
                  {imagePreview ? 'Change Image' : 'Upload Image'}
                </Typography>
                <input
                  onChange={e => {
                    handleFileChange(e, subject?.subjectId)
                  }}
                  hidden
                  multiple
                  accept='image/*'
                  type='file'
                  id='image'
                  name='image'
                />
              </Button>
            </Stack>
          </Grid> */}
          <Grid item xs={12} sm={12}>
            <FormLayout>
              <Select
                onChange={e => {
                  handleUserTypeChange(e, subject?.subjectId, subject?.subjectRenderType)
                }}
                value={subject?.subjectRenderType}
                IconComponent={ArrowIcon}
                displayEmpty
                renderValue={
                  subject?.subjectRenderType !== ''
                    ? undefined
                    : () => (
                        <Typography variant='bodyRegular' color={colors.TAG_TEXT_GRAY}>
                          {'Select a value'}
                        </Typography>
                      )
                }
                sx={selectStyle}
              >
                {renderSelect}
              </Select>
              {renderTextFields(subject)}

              <Stack>
                <LabelErrorTAG label='Description' />
                <TextareaAutosize
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    onChangeTextArea(e, subject?.subjectId)
                  }}
                  value={subject?.description}
                  minRows={5}
                  style={textAreaStyle}
                  id='description'
                  name='description'
                />
              </Stack>

              {renderCustomFields(subject?.subjectId)}
              <Button
                variant='outlined'
                startIcon={<AddIcon />}
                sx={{ color: colors.BLACK }}
                onClick={openModalHandler}
              >
                <Typography variant='bodyRegular' color='inherit'>
                  Add Custom Text Field
                </Typography>
              </Button>
            </FormLayout>
          </Grid>
        </Grid>
        <DividerTAG />
        <ModalTAG open={openModal}>
          <form
            onSubmit={newTagHandleSubmit(data => addNewTagSubmitHandler(data, subject?.subjectId))}
          >
            <CardTAG
              title={'Add Custom Field Title'}
              closable={true}
              closeCard={() => {
                setOpenModal(false)
              }}
            >
              <FormLayout>
                <TextInput
                  register={newTagRegister}
                  fieldName={'newTag'}
                  label={'Title'}
                  error={getMessageNewTag('newTag') as string}
                />
                <Button variant='submitFormButton' type='submit'>
                  <Typography variant='bodyBold'>Add</Typography>
                </Button>
              </FormLayout>
            </CardTAG>
          </form>
        </ModalTAG>
      </Box>
    )
  }

  const renderForms = () => {
    if (subjectsData && subjectsData?.length > 0) {
      return subjectsData?.map(subject => {
        if (subject?.subjectRenderType !== '') {
          return resolveForm(subject)
        }
        return (
          <Box sx={{ width: '100%', marginTop: '1.8rem' }} key={`${subject?.subjectId}-selectType`}>
            {' '}
            <Select
              onChange={e => {
                handleUserTypeChange(e, subject?.subjectId, subject?.subjectRenderType)
              }}
              value={subject?.subjectRenderType}
              IconComponent={ArrowIcon}
              displayEmpty
              renderValue={
                subject?.subjectRenderType !== ''
                  ? undefined
                  : () => (
                      <Typography variant='bodyRegular' color={colors.TAG_TEXT_GRAY}>
                        {'Select a value'}
                      </Typography>
                    )
              }
              sx={selectStyle}
            >
              {renderSelect}
            </Select>
          </Box>
        )
      })
    }
  }

  return (
    <>
      <>
        <FormLayout>
          <Button startIcon={<AddIcon />} variant='submitFormButton' onClick={addSubjectHandler}>
            <Typography variant='bodyBold'>Add Person</Typography>
          </Button>
          <DividerTAG />
        </FormLayout>
      </>
      {renderForms()}
    </>
  )
}
export default SubjectFormQuestion
